import axios from "utils/axiosConfig";
import { urlService } from "infra/envs";

class LoginApi {
    async loginRequest(credentials) {
        const loginUserURL = urlService.AUTH_LOGIN_PATH;
        const response = await axios.post(loginUserURL, credentials);
        return response?.data;
    }
}

const loginApiInstance = new LoginApi();
export default loginApiInstance;
